import React, { forwardRef } from 'react';

// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Slide
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

export default function ConfirmAlertDialog({
  openConfirmAlertDialog,
  message,
  title,
  positiveBtnLable,
  negativeBtnLable,
  handleClose,
  handlePositiveClose,
  handleNegativeClose,
  isLoading
}) {
  return (
    <Dialog
      open={openConfirmAlertDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="confirm-alert-dialog-desc"
      data-testid="confirm-alert-modal"
    >
      <DialogTitle sx={{ fontSize: { xs: 16, sm: 18 } }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{ fontSize: { xs: '12px', sm: '14px' } }}
          id="confirm-alert-dialog-desc"
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" size="small" onClick={handleNegativeClose}>
          {negativeBtnLable}
        </Button>
        {positiveBtnLable && (
          <LoadingButton
            variant="contained"
            size="small"
            onClick={handlePositiveClose}
            loading={isLoading}
          >
            {positiveBtnLable}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
}
